export enum SocialLoginProviderModel {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    APPLE = 'apple',
}
